import { parsePhoneNumber } from 'libphonenumber-js/max'
import * as yup from 'yup'
import {
  INVALID_PHONE_FORMAT_MESSAGE,
  THIS_FIELD_IS_REQUIRED_MESSAGE,
} from '../constants/validations'
import {
  accountNoTypeCountries,
  clearingMemberIdCountries,
  creditorAgentBranchIdCountries,
  creditorAgentBranchNameCountries,
  creditorContractPhoneCountries,
  creditorTaxIdCountries,
} from '../stubs'

export const SpecificReqFieldsInputSchema = yup.object().shape({
  creditorTaxId: yup
    .string()
    .test('creditorTaxId', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      const bic = this.parent.swift
      const bankCountry = bic?.substring(4, 6)?.toLowerCase()
      if (bankCountry && creditorTaxIdCountries.includes(bankCountry)) {
        return !!value
      }
      return true
    }),
  creditorContractPhone: yup
    .string()
    .test('creditorPhone', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      const bic = this.parent.swift
      const bankCountry = bic?.substring(4, 6)?.toLowerCase()
      if (bankCountry && creditorContractPhoneCountries.includes(bankCountry)) {
        return !!value
      }
      return true
    })
    .test({
      name: 'invalidPhoneFormat',
      message: INVALID_PHONE_FORMAT_MESSAGE,
      test: function (value) {
        try {
          if (value) {
            const phoneNumber = parsePhoneNumber(value)
            return !!phoneNumber && phoneNumber.isValid()
          }
          return true
        } catch {
          return false
        }
      },
    }),
  memberId: yup.string().test('memberId', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
    const activeTab = !!this.parent.accountNumber
    const bic = this.parent.swift
    const bankCountry = bic?.substring(4, 6)?.toLowerCase()
    if (bankCountry && clearingMemberIdCountries.includes(bankCountry) && activeTab) {
      return !!value
    }

    return true
  }),
  agentBranchId: yup
    .string()
    .test('agentBranchId', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      const bic = this.parent.swift
      const bankCountry = bic?.substring(4, 6)?.toLowerCase()
      if (bankCountry && creditorAgentBranchIdCountries.includes(bankCountry)) {
        return !!value
      }
      return true
    }),
  agentBranchName: yup
    .string()
    .test('agentBranchName', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      const bic = this.parent.swift
      const bankCountry = bic?.substring(4, 6)?.toLowerCase()
      if (bankCountry && creditorAgentBranchNameCountries.includes(bankCountry)) {
        return !!value
      }
      return true
    }),
  accountNoType: yup
    .string()
    .test('accountNoType', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      const activeTab = !!this.parent.accountNumber
      const bic = this.parent.swift
      const bankCountry = this.parent.destinationBankCountry || bic?.substring(4, 6)?.toLowerCase()
      if (bankCountry && accountNoTypeCountries.includes(bankCountry) && activeTab) {
        return !!value
      }

      return true
    }),
})
